<template>
  <header class="site-header" id="site-header" :class="{ 'is-scrolled': isScrolled }">
    <div class="container header-inner">
      <router-link class="brand" to="/">
        <div class="brand-mark" aria-hidden="true">
          <img :src="$oss('static/img/logo.png')" :alt="isZh ? '互荣万顺 logo' : 'HRWS logo'" />
        </div>
        <span>{{ companyName }}</span>
      </router-link>

      <nav class="site-nav" :aria-label="isZh ? '主导航' : 'Main Navigation'">
        <router-link to="/">{{ $t('nav.home') }}</router-link>
        <router-link to="/about">{{ $t('nav.about') }}</router-link>
        <router-link to="/products">{{ $t('nav.products') }}</router-link>
        <router-link to="/applications">{{ $t('nav.applications') }}</router-link>
        <router-link to="/quality">{{ $t('nav.quality') }}</router-link>
        <router-link to="/news">{{ $t('nav.news') }}</router-link>
        <router-link to="/contact">{{ $t('nav.contact') }}</router-link>
        <div class="lang-switch" role="group" aria-label="language switch">
          <button type="button" class="lang-btn" :class="{ 'is-active': isZh }" @click="changeLocale('zh-CN')">{{ $t('common.langZh') }}</button>
          <button type="button" class="lang-btn" :class="{ 'is-active': !isZh }" @click="changeLocale('en-US')">{{ $t('common.langEn') }}</button>
        </div>
      </nav>
      <button class="nav-toggle" type="button" :aria-label="$t('common.menu')" @click="toggleNav">{{ $t('common.menu') }}</button>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  computed: {
    isZh() {
      return this.$getLocale() === 'zh-CN'
    },
    companyName() {
      return this.isZh
        ? '湖州互荣万顺特材科技有限公司'
        : 'Huzhou HRWS Special Materials'
    }
  },
  data() {
    return {
      isScrolled: false
    }
  },
  watch: {
    // 路由切换时关闭移动端菜单、重置滚动状态
    $route() {
      document.body.classList.remove('nav-open')
      this.isScrolled = false
    }
  },
  mounted() {
    this._onScroll = () => {
      // 首页时在 hero 区域下方才显示实底背景（由 Home.vue 控制 is-scrolled）
      // 非首页直接加实底
      if (!document.body.classList.contains('page-home')) {
        this.isScrolled = true
        return
      }
      const heroCinema = document.querySelector('[data-hero-cinema]')
      const thr = heroCinema
        ? Math.min(Math.floor(heroCinema.offsetHeight * 0.16), 96)
        : 48
      this.isScrolled = (window.scrollY || document.documentElement.scrollTop) > thr
    }
    window.addEventListener('scroll', this._onScroll, { passive: true })
    window.addEventListener('resize', this._onScroll, { passive: true })
    this._onScroll()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this._onScroll)
    window.removeEventListener('resize', this._onScroll)
  },
  methods: {
    changeLocale(locale) {
      this.$setLocale(locale)
      const key = (this.$route && this.$route.meta && this.$route.meta.titleKey) || 'titles.default'
      document.title = this.$t(key)
    },
    toggleNav() {
      document.body.classList.toggle('nav-open')
    }
  }
}
</script>
